export const patient_responsibility = {
  PI: [204],
  CO: [51]
};

export const denied_codes = {
  CO: ['B7']
};
